module.exports = __webpack_public_path__ + "img/fullscreen.77b115a6.svg";